import { jsx } from 'react/jsx-runtime';
import { useLocalization } from '@shared-ui/localization-context';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-loader.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const Loader = props => {
  const {
    className,
    isDarkBackground,
    isSmall,
    entryAnimation = false,
    l10n,
    title,
    ...attributes
  } = props;
  const loaderTitle = title || l10n.formatText('loading');
  const baseClassName = 'uitk-loader';
  const cssClassNames = getClassNameList(baseClassName, className, {
    [`${baseClassName}-dark`]: isDarkBackground,
    [`${baseClassName}-small`]: isSmall,
    [`${baseClassName}-animate`]: entryAnimation
  });
  return jsx("span", {
    className: cssClassNames,
    title: loaderTitle,
    ...attributes,
    children: jsx("span", {
      className: "is-visually-hidden",
      children: loaderTitle
    })
  });
};
const EGDSLoader = props => {
  const l10n = useLocalization();
  return jsx(Loader, {
    l10n: l10n,
    ...props
  });
};
EGDSLoader.displayName = 'EGDSLoader';
export { EGDSLoader, Loader };